module.exports = __webpack_public_path__ + "img/header_icon3.ed6c3410.png";